





























































import Vue from "vue";
import ClipboardButton from "@/components/clipboard-button/clipboard-button.vue";

import { LocaleMessages } from "vue-i18n";
import { generateRandomString } from "@/utils/generate-random-string";

import {
  EPxButtonSize,
  EPxButtonType,
} from "@/components/px-button/px-button.types";
import { SHARE_MODAL_EVENTS } from "@/components/share-modal/share-modal.types";

export default Vue.extend({
  name: "ShareModalSettingsPasscode",

  components: {
    ClipboardButton,
  },

  props: {
    passcode: {
      type: String,
      required: true,
    },

    needsReset: {
      type: Boolean,
      default: false,
    },

    copy: {
      type: String,
      default: "milestonePlanner.shareModal.passcode",
    },
  },

  data() {
    return {
      innerPasscode: "",
      isRestrictedByPasscode: false,
    };
  },

  static: {
    resetButton: {
      icon: "password-lock--red",
      size: EPxButtonSize.SMALL,
      type: EPxButtonType.GHOST_RED,
    },
  },

  computed: {
    resetButtonProps(): any {
      return {
        ...this.$options.static.resetButton,
        label: this.passcodeCopy.resetButton,
      };
    },

    passcodeCopy(): LocaleMessages {
      return this.$t(this.copy) as LocaleMessages;
    },

    hasPasscode(): boolean {
      return !!this.passcode.length;
    },
  },

  watch: {
    passcode(newPasscode: string) {
      if (this.innerPasscode !== newPasscode) {
        this.innerPasscode = newPasscode;
      }
    },

    innerPasscode(newPasscode: string) {
      if (this.passcode !== newPasscode) {
        this.$emit("update:passcode", newPasscode);
      }
    },

    needsReset(needsReset: boolean) {
      if (needsReset) {
        this.isRestrictedByPasscode = this.hasPasscode;
        this.$emit("update:needsReset", !needsReset);
      }
    },
  },

  created() {
    this.isRestrictedByPasscode = this.hasPasscode;

    if (this.hasPasscode) {
      this.innerPasscode = this.passcode;
    }
  },

  methods: {
    changeRestrictionHandler(isRestricted: boolean) {
      // If non-existing passcode, generate a new one:
      if (isRestricted && !this.hasPasscode && !this.innerPasscode) {
        this.innerPasscode = generateRandomString();
      }

      this.$emit("change", isRestricted, this.innerPasscode);
    },

    clickResetPasscodeHandler() {
      this.$root.$emit("share-modal-action", {
        event: SHARE_MODAL_EVENTS.RESET_PASSCODE,
      });
    },
  },
});
